import * as React from 'react';

import { BaseInput } from '../shared/base-input';

export function HeaderFilter({
  useContextFn,
  placeHolder,
  label,
  errorMessages = {},
}: {
  useContextFn: () => {
    header: string;
    setHeader: (value: string) => void;
  };
  placeHolder?: string;
  label?: string;
  errorMessages?: Record<string, string>;
}) {
  const { header: value, setHeader: onChange } = useContextFn();
  const helperText = errorMessages['header'];
  return (
    <BaseInput
      label={label ?? 'Header'}
      placeHolder={placeHolder ?? 'Header'}
      q={value}
      writeQ={onChange}
      type="text"
      multiline
      rows={3}
      error={!!helperText}
      helperText={helperText}
    />
  );
}
